<ng-container [ngSwitch]="mode$ | async">
	<ng-container *ngSwitchCase="'base'">
		<rx-intuitive-teeth-orchestrator *ngIf="isToothChartViewMode$ | async"></rx-intuitive-teeth-orchestrator>
		<rx-intuitive-treatment-table-container *ngIf="isTreatmentTableViewMode$ | async"></rx-intuitive-treatment-table-container>
	</ng-container>
	<ng-container *ngSwitchCase="'bridge'">
		<rx-intuitive-teeth-bridge-orchestrator *ngIf="isToothChartViewMode$ | async"></rx-intuitive-teeth-bridge-orchestrator>
		<rx-intuitive-treatment-table-container *ngIf="isTreatmentTableViewMode$ | async"></rx-intuitive-treatment-table-container>
	</ng-container>
	<rx-intuitive-art-orchestrator *ngSwitchCase="'art'"></rx-intuitive-art-orchestrator>
</ng-container>
